import { blogAPI, courseRegAPI } from '../api/Axios';
import axios from 'axios';

export const sendCourseRegistrationConfirmation = async (subscriberEmailId) => {
  try {
    const status = await blogAPI.put(`/api/dd-course/public/registration/send-confirmation/${subscriberEmailId}`);
    console.log(status);
  } catch (err) {
    if (err.response) {
      // The client was given an error response (5xx, 4xx)
      console.log(err.response.data);
      console.log(err.response.status);
      console.log(err.response.headers);
    } else if (err.request) {
      // The client never received a response, and the request was never left
      console.log(err.request);
    } else {
      console.log('Error while sending course registration confirmation', err.message);
    }
  }
};


export const createCourseRegistration = async (values) => {
  try {
    const response = await blogAPI.post('/api/dd-course/public/registration/submit-form', JSON.stringify(values));
    console.log(JSON.stringify(response.data));
    return response.data;
  } catch (err) {
    if (err.response) {
      // The client was given an error response (5xx, 4xx)
      console.log(err.response.data);
      console.log(err.response.status);
      console.log(err.response.headers);
    } else if (err.request) {
      // The client never received a response, and the request was never left
      console.log(err.request);
    } else {
      console.log('Error while registering new user for the course', err.message);
    }
  }
};

export const generateOTP = async (values) => {
  let data = JSON.stringify(values);
  let config = {
    method: 'post',
    url: '/api/validate-num',
    data: data,
  };

  return courseRegAPI.request(config)
    .then((response) => {
      console.log(response);
      return response;
    })
    .catch((err) => {
      if (err.response) {
        // The client was given an error response (5xx, 4xx)
        console.log(err.response.data);
        console.log(err.response.status);
        console.log(err.response.headers);
      } else if (err.request) {
        // The client never received a response, and the request was never left
        console.log(err.request);
      } else {
        console.log('Error while generating mobile otp', err.message);
      }
    });

}

export const verifyOTP = async (values) => {
  let data = JSON.stringify(values);

  let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: '/api/verify-otp',
    data: data
  };

  return courseRegAPI.request(config)
    .then((response) => {
      console.log(JSON.stringify(response.data));
      return response;
    })
    .catch((err) => {
      if (err.response) {
        // The client was given an error response (5xx, 4xx)
        console.log(err.response.data);
        console.log(err.response.status);
        console.log(err.response.headers);
      } else if (err.request) {
        // The client never received a response, and the request was never left
        console.log(err.request);
      } else {
        console.log('Error while validating OTP', err.message);
      }
      return err?.response;
    });

}
export const registerUser = async (values) => {
  let data = JSON.stringify(values);
  let phone = JSON.stringify(values.phone);
  console.log(phone, data);

  let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: '/api/reg',
    data: data,
    // headers:{'phone':918349528372}
  };

  return courseRegAPI.request(config)
    .then((response) => {
      console.log(JSON.stringify(response.data));
      return response;
    })
    .catch((err) => {
      if (err.response) {
        // The client was given an error response (5xx, 4xx)
        console.log(err.response.data);
        console.log(err.response.status);
        console.log(err.response.headers);
      } else if (err.request) {
        // The client never received a response, and the request was never left
        console.log(err.request);
      } else {
        console.log('Error while registering new user', err.message);
      }
      return err.response;
    });

}

export const downloadBrochure = async (link)=>{
  fetch(link)
  .then((response) => {
    response.blob().then((blob) => {
        const fileURL =window.URL.createObjectURL(blob);
          
        let alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = "Brochure.pdf";
        alink.click();
    });
});
}

export const uploadResumeOncloud = (url,fields,file) =>{
  const formData = new FormData();

  for (const key in fields) {
      formData.append(key, fields[key]);
  }
  formData.append('file', file)
  
  return fetch(url,
    {
      method:'POST',
      body:formData,
    }
  )
  .then((res)=>{console.log(res); return res})
  .catch((err)=>{console.log(err); return err});
}


export const uploadResume = async (mobileno)=>{

  let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: '/api/upload-cv',
    params:{'phone':mobileno}
  };

  return courseRegAPI.request(config)
    .then((response) => {
      console.log(JSON.stringify(response.data));

      return response;
    })
    .catch((err) => {
      console.log(err)
    })
  
   
}

